<template>
  <div class="match-page">

    <!-- Filter Panel -->
    <div class="filter-panel">
      <div class="filter-row">

        <div class="filter-group">
          <span class="filter-label">{{ $t("maidType") }}</span>
          <div class="pill-toggle">
            <button class="pill-btn" :class="{ active: maidType === 'Oversea' }"
              @click="maidType = maidType === 'Oversea' ? null : 'Oversea'">
              {{ $t("OverseaShort") }}
            </button>
            <button class="pill-btn" :class="{ active: maidType === 'Local' }"
              @click="maidType = maidType === 'Local' ? null : 'Local'">
              {{ $t("LocalShort") }}
            </button>
          </div>
        </div>

        <div class="filter-group">
          <span class="filter-label">{{ $t("nationality") }}</span>
          <div class="pill-toggle">
            <button class="pill-btn" :class="{ active: maidNationality === 'Indonesian' }"
              @click="maidNationality = maidNationality === 'Indonesian' ? null : 'Indonesian'">
              {{ $t("Indonesian") }}
            </button>
            <button class="pill-btn" :class="{ active: maidNationality === 'Filipino' }"
              @click="maidNationality = maidNationality === 'Filipino' ? null : 'Filipino'">
              {{ $t("Filipino") }}
            </button>
          </div>
        </div>

        <div class="filter-group">
          <span class="filter-label">{{ $t("age") }}</span>
          <div class="pill-toggle">
            <button class="pill-btn" :class="{ active: maidAge === '21-30' }"
              @click="maidAge = maidAge === '21-30' ? null : '21-30'">21–30</button>
            <button class="pill-btn" :class="{ active: maidAge === '31-40' }"
              @click="maidAge = maidAge === '31-40' ? null : '31-40'">31–40</button>
            <button class="pill-btn" :class="{ active: maidAge === '41+' }"
              @click="maidAge = maidAge === '41+' ? null : '41+'">41+</button>
          </div>
        </div>

        <div class="filter-group">
          <span class="filter-label">{{ $t("skill") }}</span>
          <div class="skill-toggle">
            <button class="skill-btn" :class="{ active: maidSkill.includes('newborn') }"
              @click="toggleSkill('newborn')" title="Newborn">
              <v-icon small>mdi-baby-carriage</v-icon>
            </button>
            <button class="skill-btn" :class="{ active: maidSkill.includes('child') }"
              @click="toggleSkill('child')" title="Child">
              <v-icon small>mdi-human-male-child</v-icon>
            </button>
            <button class="skill-btn" :class="{ active: maidSkill.includes('elderly') }"
              @click="toggleSkill('elderly')" title="Elderly">
              <v-icon small>mdi-human-cane</v-icon>
            </button>
            <button class="skill-btn" :class="{ active: maidSkill.includes('disable') }"
              @click="toggleSkill('disable')" title="Disability">
              <v-icon small>mdi-human-wheelchair</v-icon>
            </button>
          </div>
        </div>

      </div>

      <button class="filter-apply-btn" @click="filterResult">
        {{ $t('filter') || 'Apply Filters' }}
        <svg class="btn-arrow" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 10h12M11 5l5 5-5 5" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="loading-state">
      <v-progress-circular indeterminate color="#0A7A76" size="48"></v-progress-circular>
    </div>

    <!-- Helper Grid -->
    <div v-else-if="items.length > 0" class="helper-grid">
      <div v-for="item in pagedItems" :key="item.id || item.name" class="helper-card">
        <div class="card-photo-wrap">
          <img
            v-if="item.fileLocation && !item.fileLocation.includes('/null')"
            :src="`https://storage.googleapis.com/starjasmine-aacba.appspot.com/${item.fileLocation}`"
            class="card-photo"
            :alt="item.name"
          />
          <div v-else class="card-photo-placeholder">
            <v-icon size="56" color="#cbd5e1">mdi-account</v-icon>
          </div>
          <span class="nationality-badge">{{ $t(item.nationality) }}</span>
        </div>
        <div class="card-body">
          <h3 class="card-name">{{ item.name }}</h3>
          <p class="card-id">ID: {{ item.portfolioId }}</p>
          <div class="card-chips">
            <span class="info-chip">{{ $t('age') }} {{ item.age }}</span>
            <span class="info-chip status-chip">{{ $t(item.status) }}</span>
          </div>
          <button class="download-btn" @click="downloadPDF(item)">
            {{ $t('downloadBioData') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div v-else class="empty-state">
      <v-icon size="64" color="#cbd5e1">mdi-account-search</v-icon>
      <p>No helpers found. Try adjusting your filters.</p>
    </div>

    <!-- Pagination -->
    <div v-if="!loading && items.length > 0" class="pagination-row">
      <div class="page-nav">
        <button class="page-btn" @click="formerPage" :disabled="page <= 1">
          <v-icon>mdi-chevron-left</v-icon>
        </button>
        <span class="page-info">{{ page }} / {{ numberOfPages }}</span>
        <button class="page-btn" @click="nextPage" :disabled="page >= numberOfPages">
          <v-icon>mdi-chevron-right</v-icon>
        </button>
      </div>
      <div class="per-page-group">
        <span class="filter-label">Per page:</span>
        <button v-for="n in itemsPerPageArray" :key="n"
          class="pill-btn small" :class="{ active: itemsPerPage === n }"
          @click="updateItemsPerPage(n)">{{ n }}</button>
      </div>
    </div>

  </div>
</template>


<script>
import axios from "axios";
export default {
  props: {
    franchaseCode: {
      type: String,
      default: null
    }
  },
  async mounted() {
    let data = await axios.get(
      `https://asia-east2-starjasmine-aacba.cloudfunctions.net/matching/gethelpers/${this.franchaseCode ?? ""}`
    );
    const sorted = this.sortBySubmitDate(data.data);
    this.items = sorted;
    this.rawItems = sorted;
    this.loading = false;
  },
  data() {
    return {
      loading: true,
      maidSkill: [],
      rawItems: [],
      maidType: null,
      maidNationality: null,
      maidAge: null,
      items: [],
      itemsPerPageArray: [12, 24, 48],
      page: 1,
      itemsPerPage: 12,
      keys: ['Name', 'portfolioId', 'nationality', 'age'],
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== 'Name');
    },
    pagedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      return this.items.slice(start, start + this.itemsPerPage);
    },
  },
  methods: {
    toggleSkill(skill) {
      const idx = this.maidSkill.indexOf(skill);
      if (idx === -1) this.maidSkill.push(skill);
      else this.maidSkill.splice(idx, 1);
    },
    titlechange(k) {
      switch (k) {
        case "portfolioId": return this.$t('PortfolioID');
        case "nationality": return this.$t('nationality');
        case "age": return this.$t('age');
        default: return k;
      }
    },
    downloadPDF(profile) {
      window.open('https://asia-east2-starjasmine-aacba.cloudfunctions.net/matching/url?p=AITI-KI-0028&url=https://maidexpert.hk/fetch/' + profile.id);
    },
    filterResult() {
      this.page = 1;
      this.items = this.rawItems;
      if (this.maidType) {
        this.items = this.items.filter(i => i.status === this.maidType);
      }
      if (this.maidNationality) {
        this.items = this.items.filter(i => i.nationality === this.maidNationality);
      }
      if (this.maidAge) {
        switch (this.maidAge) {
          case "21-30": this.items = this.items.filter(i => i.age >= 21 && i.age <= 30); break;
          case "31-40": this.items = this.items.filter(i => i.age >= 31 && i.age <= 40); break;
          case "41+":   this.items = this.items.filter(i => i.age >= 41); break;
        }
      }
      if (this.maidSkill.length > 0) {
        if (this.maidSkill.includes("newborn"))  this.items = this.items.filter(i => i.careInfant >= 3);
        if (this.maidSkill.includes("child"))    this.items = this.items.filter(i => i.careChild >= 3);
        if (this.maidSkill.includes("elderly"))  this.items = this.items.filter(i => i.careElderly >= 3);
        if (this.maidSkill.includes("disable"))  this.items = this.items.filter(i => i.careDisabled >= 3);
      }
      this.items = this.sortBySubmitDate(this.items);
    },
    sortBySubmitDate(arr) {
      return [...arr].sort((a, b) => {
        const da = a.submitDate ? new Date(a.submitDate).getTime() : 0;
        const db = b.submitDate ? new Date(b.submitDate).getTime() : 0;
        return db - da;
      });
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
      this.page = 1;
    },
  },
};
</script>

<style scoped>
.match-page {
  padding: 8px 0 40px;
}

/* ── Filter Panel ── */
.filter-panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}
.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 20px;
}
.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.pill-toggle {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.pill-btn {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 50px;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s;
}
.pill-btn:hover {
  border-color: #0A7A76;
  color: #0A7A76;
}
.pill-btn.active {
  background: #0A7A76;
  border-color: #0A7A76;
  color: #fff;
}
.pill-btn.small {
  padding: 4px 12px;
  font-size: 12px;
}
.skill-toggle {
  display: flex;
  gap: 6px;
}
.skill-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #f1f5f9;
  color: #475569;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.skill-btn:hover {
  border-color: #0A7A76;
  color: #0A7A76;
}
.skill-btn.active {
  background: #0A7A76;
  border-color: #0A7A76;
  color: #fff;
}
.filter-apply-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #0A7A76;
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 11px 28px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(10, 122, 118, 0.25);
  transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
}
.filter-apply-btn:hover {
  background: #085E5B;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(10, 122, 118, 0.3);
}
.btn-arrow {
  width: 16px;
  height: 16px;
}

/* ── Loading / Empty ── */
.loading-state {
  display: flex;
  justify-content: center;
  padding: 80px 0;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 80px 0;
  color: #94a3b8;
  font-size: 15px;
}

/* ── Helper Grid ── */
.helper-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
}
.helper-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  transition: transform 0.2s, box-shadow 0.2s;
}
.helper-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(10, 122, 118, 0.15);
}
.card-photo-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  background: #f1f5f9;
  overflow: hidden;
}
.card-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.card-photo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
}
.nationality-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(10, 122, 118, 0.9);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 50px;
  letter-spacing: 0.3px;
}
.card-body {
  padding: 14px 16px 16px;
}
.card-name {
  font-size: 15px;
  font-weight: 700;
  color: #0A7A76;
  margin: 0 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-id {
  font-size: 12px;
  color: #94a3b8;
  margin: 0 0 10px;
}
.card-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.info-chip {
  background: #E4F6F5;
  color: #0A7A76;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 50px;
}
.status-chip {
  background: #fff7ed;
  color: #c2710c;
}
.download-btn {
  width: 100%;
  border: 1px solid #0A7A76;
  border-radius: 50px;
  background: transparent;
  color: #0A7A76;
  font-size: 12px;
  font-weight: 600;
  padding: 7px 0;
  cursor: pointer;
  transition: all 0.2s;
}
.download-btn:hover {
  background: #0A7A76;
  color: #fff;
}

/* ── Pagination ── */
.pagination-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}
.page-nav {
  display: flex;
  align-items: center;
  gap: 12px;
}
.page-info {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  min-width: 60px;
  text-align: center;
}
.page-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.page-btn:hover:not(:disabled) {
  border-color: #0A7A76;
  color: #0A7A76;
}
.page-btn:disabled {
  opacity: 0.35;
  cursor: default;
}
.per-page-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

@media (max-width: 600px) {
  .filter-row { flex-direction: column; }
  .helper-grid { grid-template-columns: repeat(2, 1fr); gap: 12px; }
  .card-photo-wrap { aspect-ratio: 2 / 3; }
}
</style>
